














































































































































































































import { Editor } from '@tiptap/core';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class ActionTable extends Vue {
  @Prop()
  editor: Editor;
}
